/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown>, fps: NonNullable<unknown> }} Video_Export_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Exporting - {progress}% \| {fps}FPS" |
*
* @param {Video_Export_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_progress_label = /** @type {((inputs: Video_Export_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportieren - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出 - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エクスポート中 - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`निर्यात हो रहा है - ${i?.progress}% | ${i?.fps}FPS`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando - ${i?.progress}% | ${i?.fps}FPS`)
	return /** @type {LocalizedString} */ (`Exporting - ${i?.progress}% | ${i?.fps}FPS`)
});